// extracted by mini-css-extract-plugin
module.exports = {"ant-descriptions-view":"Finish_ant-descriptions-view__3yicO","descriptionItem":"Finish_descriptionItem__3mn6O"};